export default __webpack_public_path__ + "static/media/keynote3.172a5afe.jpeg";